import { render, staticRenderFns } from "./Autismo.vue?vue&type=template&id=020038de&scoped=true"
import script from "./Autismo.vue?vue&type=script&lang=js"
export * from "./Autismo.vue?vue&type=script&lang=js"
import style0 from "./Autismo.vue?vue&type=style&index=0&id=020038de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020038de",
  null
  
)

export default component.exports